export const HeaderTablePaymentSchemeDetail = [
  'Description',
  'Percentage',
  'Interval Day',
  'Lock Guest',
  'Action',
];
